import React, { Component } from "react";
import { Button, Image, Typography } from "antd";
import { removeStorageWhenLogout, statusHtmlStorage } from "../../config/helper";
import resetIcon from "../../assets/img/image-reset.png";
import styles from "./reset.module.css";

class ResetSuccess extends Component {
  componentDidMount() {
    if (!statusHtmlStorage("reset-message")) {
      removeStorageWhenLogout();
      window.location.href = "/signin";
    }
    // setTimeout(() => {
    //   window.location.href = "/signin";
    // }, 120000);
  }

  render() {
    return (
      <div className={styles.auth_reset_page}>
        <div className={styles.auth_wrapper}>
          <div className={styles.reset_success_wrapper}>
            <Image preview={false} src={resetIcon} />
            <Typography.Title level={3}>
              Password Changed Successfully!
            </Typography.Title>
            <Typography.Paragraph>
              Your password has been successfully updated. Please use your new
              password to Sign In to your account.
            </Typography.Paragraph>
            <Button type="link" href="/signin" className={styles.btn_reset}>
              Sign In
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetSuccess;
